module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/icon_how-to-enjoy-sola-6061b75a4c53297f96c8e3ffa6c60568.png";